import * as challengeApi from '@/network/api/challenge.api.js'

export const preLoadStoreData = (context, payload) => {
	context.commit('PRE_LOAD_STORE_DATA')
}

export const saveRouteForRedirectAfterRefresh = (context, payload) => {
	context.commit('SAVE_ROUTE_FOR_DIRECT_AFTER_REFRESH', payload)
}

/** updates device where our app is running
@payload { String } - desktop, iOS or android
@return { void }
*/
export const updateDeviceInUse = (context, payload) => {
	context.commit('UPDATE_DEVICE_IN_USE', payload)
}

/** updates isMobileApp state
@payload { Boolean }
@return { void }
*/
export const updateIsMobileApp = (context, payload) => {
	context.commit('UPDATE_IS_MOBILE_APP', payload)
}

/** updates show alert rememberMe Modal state
@payload { Boolean }
@return { void }
*/
export const updateShowAlertRememberMeModal = (context, payload) => {
	context.commit('UPDATE_SHOW_ALERT_REMEMBER_ME_MODAL', payload)
}
/**************************************************
*												  *
*                Visual Helpers Logic             *
*												  *
**************************************************/
/** updates status bar color stlye state
@payload { Boolean } - [light, default]
@return { void }
*/
export const updateStatusBarStyle = (context, payload) => {
	context.commit('UPDATE_STATUS_BAR_STYLE', payload)
}

/** updates app theme state
@payload { String } - [particular, company]
@return { void }
*/
export const updateAppThemeClientType = (context, payload) => {
	context.commit('UPDATE_APP_THEME_CLIENT_TYPE', payload)
}

/** updates app themeMode color  state
@payload { String } - [light, dark]
@return { void }
*/
export const updateAppThemeMode = (context, payload) => {
	console.log(payload)
	context.commit('UPDATE_APP_THEME_MODE', payload)
}

/** updates preventMobileFeatureBack state
@payload { Boolean }
@return { void }
*/
export const updatePreventMobileFeatureBack = (context, payload) => {
	context.commit('UPDATE_PREVENT_MOBILE_FEATURE_BACK', payload)
}

/** updates preventMobileSideModalBack state
@payload { Boolean }
@return { void }
*/
export const updatePreventMobileSideModalBack = (context, payload) => {
	context.commit('UPDATE_PREVENT_MOBILE_SIDE_MODAL_BACK', payload)
}

/** updates app view scroll position in store
@payload { Number }
@return { void }
*/
export const updateAppScroll = (context, payload) => {
	context.commit('UPDATE_APP_SCROLL_POSITION', payload)
}

/** updates side Modal scroll position in store
@payload { Number }
@return { void }
*/
export const updateSideModalScroll = (context, payload) => {
	context.commit('UPDATE_SIDE_MODAL_SCROLL_POSITION', payload)
}

/** updates state of footer being showed or not
@payload { Boolean }
@return { void }
*/
export const updateFooterShowState = (context, payload) => {
	context.commit('UPDATE_FOOTER_SHOW_STATE', payload)
}

/** updates state of keyboard height
@payload { String }
@return { void }
*/
export const updateKeyboardHeight = (context, payload) => {
    context.commit('UPDATE_KEYBOARD_HEIGHT_STATE', payload)
}

/** updates state of App transparency
@payload { Boolean }
@return { void }
*/
export const updateApplyTransparencyToApp = (context, payload) => {
	context.commit('UPDATE_APP_TRANSPARENCY_STATE', payload)
}

/**************************************************
*												  *
*                Requests list Logic           	  *
*												  *
**************************************************/
/** Add request to list of requests pending
@return { void }
*/
export const addToRequestsList = (context, payload) => {
	setTimeout(() => {
		context.commit('ADD_TO_REQUESTS_LIST', payload)
	})
}

/** clears all pending requests
@return { void }
*/
export const cancelAllPendingRequests = (context, payload) => {
	context.commit('CLEAR_ALL_PENDING_REQUESTS')
}

/**************************************************
*												  *
*                 ROUTE PARAMS Logic           	  *
*												  *
**************************************************/
/** saves route params in store
@return { void }
*/
export const saveRouteParams = (context, payload) => {
	context.commit('SAVING_ROUTE_PARAMS', payload)
}

/** removes route params from store
@return { void }
*/
export const removeRouteParams = (context, payload) => {
	context.commit('REMOVING_ROUTE_PARAMS')
}

/**************************************************
*												  *
*	               TOKEN Modal Logic           	  *
*												  *
**************************************************/
/** updates display of token challenge modal
@payload { object } - challenge mock for token submit response
@return { void }
*/
export const showTokenChallengeModal = (context, payload) => {
	context.commit('SHOW_TOKEN_CHALLENGE_MODAL', payload)
}

/** updates display of token challenge modal to false
@return { void }
*/
export const hideTokenChallengeModal = (context, payload) => {
	context.commit('HIDE_TOKEN_CHALLENGE_MODAL')
}

export const submitChallenge = async (context, payload) => {
	const res = await challengeApi.submitChallenge(payload)
    return res
}

export const requestNewChallenge = async (context, payload) => {
	const res = await challengeApi.requestNewChallenge(payload)
    return res
}
